import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';
import useCount from './use-count';

export type AlertCountVehicle = Pick<VehicleCycledEnergyRecord, 'vehicleAlert'>;

const useAlertCount = (vehicles: AlertCountVehicle[]): number => {
  return useCount({
    items: vehicles,
    predicate: (v) => v.vehicleAlert,
  });
};

export default useAlertCount;
